/**
 * Differentiates between error and warning states.
 */
export var Severity;
(function (Severity) {
    Severity[Severity["Error"] = 1] = "Error";
    Severity[Severity["Warning"] = 2] = "Warning";
})(Severity || (Severity = {}));
